const TableSkeleton = ({ rows = 15, cols = 4 }) => {
  return (
    <tbody>
      {[...Array(rows)].map((_, rowIndex) => (
        <tr key={rowIndex} className='border-t border-border'>
          {[...Array(cols)].map((_, colIndex) =>
            colIndex === 0 ? (
              <td key={colIndex} className='px-2 py-3'>
                <div className='h-4 w-6 rounded bg-gray-300 animate-pulse'></div>
              </td>
            ) : (
              <td key={colIndex} className='px-2 py-3'>
                <div className='h-4 w-20 bg-gray-300 rounded animate-pulse'></div>
              </td>
            )
          )}
        </tr>
      ))}
    </tbody>
  );
};

export default TableSkeleton;
